<mat-toolbar class="mat-elevation-z3">
  <mat-toolbar-row>
    @if (isHandset$ | async) {
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    }
    @if ((isHandset$ | async) === false) {
      <h3>Calendar</h3>
    }
    <span class="toolbar-spacer"></span>
    <xui-date-navigator
      [date]="currentDate"
      [step]="navigatorStep"
      (dateChangedDayjs)="dateChanged($event)">
    </xui-date-navigator>
    <span class="toolbar-spacer"></span>
    <div class="d-flex flex-row justify-content-between align-items-center">
      @if (view === 'daysheet' && (isHandset$ | async) === false) {
        <button mat-icon-button (click)="addNewAppointment()" *xuiPermissionRequired="'Clinical.Patients.Read'" [disabled]="this.selectedRow === null">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button [disabled]="!appointmentsSelected" (click)="sendBulkMessage()" *xuiPermissionRequired="'Clinical.Messages.Write'">
          <mat-icon>sms</mat-icon>
        </button>
        <button mat-icon-button [disabled]="!appointmentsSelected" (click)="sendBulkEmail()" *xuiPermissionRequired="'Clinical.Emails.Write'">
          <mat-icon>email</mat-icon>
        </button>
      }
      @if ((isHandset$ | async) === false) {
        <mat-button-toggle-group [value]="view" (change)="onViewChanged($event.value)" class="view-toggle" hideSingleSelectionIndicator>
          <mat-button-toggle value="daysheet">Daysheet</mat-button-toggle>
          <mat-button-toggle value="day">Day</mat-button-toggle>
          <mat-button-toggle value="week">Week</mat-button-toggle>
          <mat-button-toggle value="month">Month</mat-button-toggle>
        </mat-button-toggle-group>
      } @else {
        <button mat-button [matMenuTriggerFor]="viewMenu" class="view-menu-trigger">
          <span>{{ viewLabel }}</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #viewMenu="matMenu">
          <button mat-menu-item (click)="onViewChanged('daysheet')">Daysheet</button>
          <button mat-menu-item (click)="onViewChanged('day')">Day</button>
          <button mat-menu-item (click)="onViewChanged('week')">Week</button>
          <button mat-menu-item (click)="onViewChanged('month')">Month</button>
        </mat-menu>
      }
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<mat-sidenav-container class="sidenav-container" [class.has-tabs]="hasTabs">
  <mat-sidenav #drawer class="sidenav"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [fixedInViewport]="true"
    [fixedTopGap]="fixedTopGap"
    [opened]="(isHandset$ | async) === false">
    <div class="controls material-calendar mt-2">
      <mat-calendar [(selected)]="currentDate" (selectedChange)="dateChanged($event)"></mat-calendar>
      <button mat-flat-button color="primary" (click)="selectToday()">Today</button>
      @if (locations.length > 0) {
        <mat-form-field class="calendar-filter-field mb-2" subscriptSizing="dynamic">
          <mat-label>Location</mat-label>
          <mat-select [(value)]="selectedLocationId" [disabled]="locationsDisabled" (selectionChange)="onFilterChanged()">
            @for (location of locations; track location.id) {
              <mat-option [value]="location.id">{{ location.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (practitioners.length > 0) {
        <mat-form-field class="calendar-filter-field" subscriptSizing="dynamic">
          <mat-label>Practitioner</mat-label>
          <mat-select [(value)]="selectedPractitionerId" [disabled]="practitionersDisabled" (selectionChange)="onFilterChanged()">
            @for (practitioner of practitioners; track practitioner.id) {
              <mat-option [value]="practitioner.id">{{ practitioner.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (loaded && appointmentTypes.length > 0) {
        <mat-expansion-panel class="appointment-types-panel" [expanded]="true" hideToggle="false">
          <mat-expansion-panel-header>
            <mat-panel-title>Appointment Types</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="appointment-types-list" [formGroup]="calendarForm">
            <div formArrayName="appointmentTypes">
              @for (control of appointmentTypesFormArray.controls; track control; let i = $index) {
                <div [formGroupName]="i" class="appointment-type-item">
                  <mat-checkbox formControlName="selected" [xuiMatCheckboxBackgroundColour]="appointmentTypes[i].displayStyle">{{appointmentTypes[i].title}}</mat-checkbox>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel>
      }
    </div>
  </mat-sidenav>
  <mat-sidenav-content #sidenavContent [class.has-tabs]="hasTabs" class="p-3">
    <mat-card appearance="outlined">
      @if (!initialized()) {
        <xui-loading-bar></xui-loading-bar>
      }
      <mat-card-content>
        <div class="calendar-zone-bar" [class.mismatch]="viewerOutOfPracticeZone">
          <span class="calendar-zone-chip">
            <mat-icon>schedule</mat-icon>
            <span>Times shown in {{ practiceTimezoneLabel }}</span>
          </span>
          @if (viewerOutOfPracticeZone) {
            <span class="calendar-zone-mismatch">
              You're in {{ deviceTimezoneLabel }} — appointment times are shown in practice time.
            </span>
          }
        </div>
        @switch (view) {
          @case ('daysheet') {
            <app-day-view
              [currentDate]="currentDate"
              [intervals]="intervals"
              [visibleAppointmentTypes]="visibleAppointmentTypes"
              [practiceLocationId]="selectedLocationId"
              [practicePractitionerId]="selectedPractitionerId"
              [appointments]="dayViewAppointments()"
              [appointmentTypes]="appointmentTypes"
              [patientDisplayFormat]="patientDisplayFormat"
              (appointmentSelectionChanged)="onAppointmentSelectionChanged($event)"
              (rowSelectionChanged)="onRowSelectionChanged($event)"
              (deleteRequested)="onDayViewDeleteRequested($event)"
              (editRequested)="onDayViewEditRequested($event)"
              (addRequested)="onDayViewAddRequested($event)"
              (viewPatientRequested)="onDayViewViewPatient($event)"
              (createPatientRequested)="onDayViewCreatePatient($event)"
              (sendMessageRequested)="onDayViewSendMessage($event)"
              (sendEmailRequested)="onDayViewSendEmail($event)"
              (reloadRequested)="loadDayViewAppointments()"
            ></app-day-view>
          }
          @case ('day') {
            <app-fullcalendar-view
              [currentDate]="currentDate"
              [view]="view"
              [visibleAppointmentTypes]="visibleAppointmentTypes"
              [practiceLocationId]="selectedLocationId"
              [practicePractitionerId]="selectedPractitionerId"
              [events]="calendarStore.calendarEvents()"
              [defaultDurationMinutes]="dataProvider.practiceSettings()?.defaultAppointmentDurationMinutes ?? 30"
              [allowDragCreate]="allowDragCreate"
              [allowTapCreate]="allowTapCreate"
              [allowDragEditing]="allowDragEditing"
              (appointmentClicked)="onFullCalendarAppointmentClicked($event)"
              (helperEventClicked)="onHelperEventClicked($event)"
              (dateRangeChanged)="onDateRangeChanged($event)"
              (appointmentMoved)="onAppointmentMoved($event)"
            ></app-fullcalendar-view>
          }
          @case ('week') {
            <app-fullcalendar-view
              [currentDate]="currentDate"
              [view]="view"
              [visibleAppointmentTypes]="visibleAppointmentTypes"
              [practiceLocationId]="selectedLocationId"
              [practicePractitionerId]="selectedPractitionerId"
              [events]="calendarStore.calendarEvents()"
              [defaultDurationMinutes]="dataProvider.practiceSettings()?.defaultAppointmentDurationMinutes ?? 30"
              [allowDragCreate]="allowDragCreate"
              [allowTapCreate]="allowTapCreate"
              [allowDragEditing]="allowDragEditing"
              (appointmentClicked)="onFullCalendarAppointmentClicked($event)"
              (helperEventClicked)="onHelperEventClicked($event)"
              (dateRangeChanged)="onDateRangeChanged($event)"
              (appointmentMoved)="onAppointmentMoved($event)"
            ></app-fullcalendar-view>
          }
          @case ('month') {
            <app-fullcalendar-view
              [currentDate]="currentDate"
              [view]="view"
              [visibleAppointmentTypes]="visibleAppointmentTypes"
              [practiceLocationId]="selectedLocationId"
              [practicePractitionerId]="selectedPractitionerId"
              [events]="calendarStore.calendarEvents()"
              [defaultDurationMinutes]="dataProvider.practiceSettings()?.defaultAppointmentDurationMinutes ?? 30"
              [allowDragCreate]="allowDragCreate"
              [allowTapCreate]="allowTapCreate"
              [allowDragEditing]="allowDragEditing"
              (appointmentClicked)="onFullCalendarAppointmentClicked($event)"
              (helperEventClicked)="onHelperEventClicked($event)"
              (dateRangeChanged)="onDateRangeChanged($event)"
              (appointmentMoved)="onAppointmentMoved($event)"
            ></app-fullcalendar-view>
          }
          @default {
            <app-day-view
              [currentDate]="currentDate"
              [intervals]="intervals"
              [visibleAppointmentTypes]="visibleAppointmentTypes"
              [practiceLocationId]="selectedLocationId"
              [practicePractitionerId]="selectedPractitionerId"
              [appointments]="dayViewAppointments()"
              [appointmentTypes]="appointmentTypes"
              [patientDisplayFormat]="patientDisplayFormat"
              (appointmentSelectionChanged)="onAppointmentSelectionChanged($event)"
              (rowSelectionChanged)="onRowSelectionChanged($event)"
              (deleteRequested)="onDayViewDeleteRequested($event)"
              (editRequested)="onDayViewEditRequested($event)"
              (addRequested)="onDayViewAddRequested($event)"
              (viewPatientRequested)="onDayViewViewPatient($event)"
              (createPatientRequested)="onDayViewCreatePatient($event)"
              (sendMessageRequested)="onDayViewSendMessage($event)"
              (sendEmailRequested)="onDayViewSendEmail($event)"
              (reloadRequested)="loadDayViewAppointments()"
            ></app-day-view>
          }
        }
      </mat-card-content>
    </mat-card>
    @if ((isHandset$ | async) && allowFabCreate) {
      <button mat-fab color="primary" class="calendar-fab" (click)="addAppointmentFromFab()" *xuiPermissionRequired="'Clinical.Patients.Read'" aria-label="New appointment">
        <mat-icon>add</mat-icon>
      </button>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
